import { Circle } from 'components/Shapes';
import BoldedValue from 'components/BoldedValue';

const ActivityCol = ({ active, merged, released }) => {
  const disabled = !active && !merged && !released;
  const textColor = disabled ? 'osloGray' : 'shark';

  return (
    <div className='flex flex-col gap-1'>
      <div className='flex flex-row items-center gap-1'>
        <Circle size='0.8' color={disabled ? 'silverSand' : 'dodgerBlue'} />
        <BoldedValue
          color={textColor}
          pl='x-small'
          value={{ size: 'small', text: active }}
          description={{ size: 'small', text: 'Active' }}
        />
      </div>
      <div className='flex flex-row items-center gap-1'>
        <Circle size='0.8' color={disabled ? 'silverSand' : 'pastelGreen'} />
        <BoldedValue
          pl='x-small'
          color={textColor}
          value={{ size: 'small', text: merged }}
          description={{ size: 'small', text: 'Merged' }}
        />
      </div>
      <div className='flex flex-row items-center gap-1'>
        <Circle size='0.8' color={disabled ? 'silverSand' : 'malachite'} />
        <BoldedValue
          pl='x-small'
          color={textColor}
          value={{ size: 'small', text: released }}
          description={{ size: 'small', text: 'Released' }}
        />
      </div>
    </div>
  );
};

export default ActivityCol;
